import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Navigate, Route, Routes } from 'react-router-dom';
import { LOCALE_TAGS } from '@jisy/shared';
import { ApiRequestError } from './api/client.js';
import { accountQuery } from './api/queries.js';
import { setLocale } from './i18n/index.js';
import { ConnectPage } from './pages/ConnectPage.js';
import { IssuesPage } from './pages/IssuesPage.js';
import { SelectSitePage } from './pages/SelectSitePage.js';
import { TableSkeleton } from './components/States.js';

export function App(): React.ReactElement {
  const account = useQuery(accountQuery);

  // Язык пользователя приходит с сервера и побеждает выбор браузера.
  useEffect(() => {
    if (account.data) {
      setLocale(account.data.me.user.locale);
      document.documentElement.lang = LOCALE_TAGS[account.data.me.user.locale];
    }
  }, [account.data]);

  const unauthenticated =
    account.isError &&
    account.error instanceof ApiRequestError &&
    (account.error.code === 'UNAUTHENTICATED' || account.error.code === 'SESSION_EXPIRED');

  if (account.isPending) {
    return <TableSkeleton rows={6} />;
  }

  return (
    <Routes>
      <Route path="/connect" element={<ConnectPage />} />
      <Route path="/select-site" element={<SelectSitePage />} />
      {/* Главная: без входа это экран подключения, после входа — таблица задач.
          Редиректа на /connect нет, чтобы адрес продукта оставался коротким. */}
      <Route
        path="/"
        element={
          unauthenticated || !account.data ? <ConnectPage /> : <IssuesPage me={account.data.me} />
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
